<template>
    <div class="main">
        <div class="bg-white">
            <div class="accountMyBox__container mx-auto text-center py-2 px-4">
                <subscription-dropdown
                    v-if="hasMultipleActiveSubscriptions"
                    :subscription-id="subscriptionId"
                    :label="label"
                    class="pt-2"/>
                <date-toggle
                    class="pt-2 pb-1"
                    @update-title="handleUpdateTitle"/>
            </div>
        </div>
        <div v-if="activeSchedule">
            <schedule-summary :key="activeSchedule.id"/>
        </div>
        <div v-else class="divider--container p-5 background--paper text-center">
            <div class="divider-white--top"></div>
            <h2 v-text="$t('YOUR_BOXES_STAY_TUNED')"></h2>
            <div class="divider-white--bottom"></div>
        </div>
        <div class="container mx-auto mb-8">
            <div class="w-full md:w-1/3 mx-auto text-center">
                <p class="inline-para" v-html="$t('YOUR_BOXES_IF_EVERYTHING')"></p>
                <p class="inline-para link" v-html="$t('YOUR_BOXES_IF_EVERYTHING_GET_IN_TOUCH')" @click="openZendesk"></p>
                <p class="inline-para" v-html="$t('YOUR_BOXES_IF_EVERYTHING_WE_WILL_SORT')"></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isDateAfter, isInCurrentWeek } from '@/helpers/DateHelpers';
import DateToggle from '@/components/partials/account/your-boxes/DateToggle';
import ScheduleSummary from '@/components/partials/account/your-boxes/ScheduleSummary';
import SubscriptionDropdown from '@/components/partials/account/rate-my-flowers/SubscriptionDropdown';

export default {
    name: 'YourBoxes',
    data() {
        return {
            subscriptionId: null,
            scheduleDate: null,
            label: null,
        };
    },
    mounted() {
        this.subscriptionId = Number(this.$route.params.subscriptionId);
        this.scheduleDate = this.$route.params.scheduleDate;

        this.$store.commit('cms/resetDeliveryDate');
        this.$store.dispatch('subscription/fetchAllSubscriptions');
        this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
        this.$store.dispatch('address/fetchAllAddresses');
        this.$store.dispatch('cms/fetchRateableArrangements');

        if (this.activeSubscription) this.$store.dispatch('cms/fetchSchedules', true);

        this.setDefaultSchedule();
    },
    computed: {
        ...mapGetters({
            hasMultipleActiveSubscriptions: 'subscription/hasMultipleActiveSubscriptions',
            activeSubscription: 'subscription/getActiveSubscription',
            activeSchedule: 'cms/getActiveSchedule',
            schedules: 'cms/getSchedules',
        }),
    },
    watch: {
        'activeSubscription.next_delivery_date'() {
            this.setDefaultSchedule();
        },
        activeSubscription() {
            this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
            this.$store.dispatch('cms/fetchSchedules', true);
        },
    },
    methods: {
        setDefaultSchedule() {
            if (this.subscriptionId && this.scheduleDate) {
                return this.$store.dispatch('cms/setActiveScheduleWeek', this.scheduleDate);
            }

            if (!this.activeSubscription || !this.activeSchedule) {
                return;
            }

            if (
                isDateAfter(this.activeSubscription.next_delivery_date, new Date()) &&
                isInCurrentWeek(this.activeSubscription.next_delivery_date, this.activeSchedule.deliveries_start_at)
            ) {
                this.$store.dispatch('cms/decrementActiveScheduleWeek');
            }
        },

        handleUpdateTitle(title) {
            this.label = this.$t('YOUR_BOXES_DELIVERED_ON', {
                label: title,
            });
        },

        openZendesk() {
            zE('webWidget', 'open');
        },
    },
    components: {
        SubscriptionDropdown,
        ScheduleSummary,
        DateToggle,
    },
};
</script>

<style scoped>
.inline-para {
    display: inline;
}
.link {
    text-decoration: underline;
    cursor: pointer;
}
</style>
